<template>
  <div style="padding: 20px; height: 100%; box-sizing: border-box">
    <div class="cf" style="padding:10px">
      <div class="fl">
        化验室审核
        <el-radio-group v-model="search.confirm" @change="fetchInit()" size="mini" style="margin: 0 10px;">
          <el-radio-button label="0">未确认</el-radio-button>
          <el-radio-button label="1">已确认</el-radio-button>
          <el-radio-button label="2">已驳回</el-radio-button>
        </el-radio-group>
        <el-input v-model="search.name" @change="fetchInit()" style="width: 200px" placeholder="请输入化验室名称" clearable
          size="mini"></el-input>
      </div>
      <div class="fr">
        <el-tooltip class="item" effect="dark" content="查询" placement="top">
          <el-button size="mini" @click="init()" circle icon="el-icon-search">
          </el-button>
        </el-tooltip>
      </div>
    </div>
    <el-table :data="data" border size="mini" style="width: 100%" height="85%" v-loading="loading"
      highlight-current-row>
      <template #empty>
        <el-empty></el-empty>
      </template>
      <el-table-column prop="headImg" label="门头图片" width="100" show-overflow-tooltip align="center">
        <template #default="{ row }">
          <el-image :src="row.headImg" style="width: 40px; height: 40px" :preview-src-list="[row.headImg]"></el-image>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="化验室" width="200" show-overflow-tooltip align="center" />
      <el-table-column prop="address" label="地址" min-width="200" show-overflow-tooltip align="center" />
      <el-table-column label="操作" width="120" align="center" v-if="search.confirm === '0'">
        <template #default="{ row }">
          <el-button type="text" size="mini" @click="setConfirm(row, '1')">确认</el-button>
          <el-button type="text" size="mini" @click="setConfirm(row, '2')" style="color: red">驳回</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align: left; padding: 10px 0">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page.current"
        :page-sizes="[20, 50, 80, 100]" :page-size="page.size" layout="total, sizes, prev, pager, next, jumper"
        :total="page.total" background>
      </el-pagination>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      data: [],
      allAlign: 'center',
      loading: false,
      page: {
        total: 0,
        size: 20,
        current: 1
      },
      search: {
        confirm: '0'
      }
    }
  },
  created() {
    this.init()
  },
  mounted() {
    this.$validate.ToDocumentTitle()
  },
  methods: {
    fetchInit() {
      this.page.current = 1
      this.init()
    },
    init() {
      this.$set(this, 'loading', true)
      const params = {
        pageNum: this.page.current,
        pageSize: this.page.size
      }
      for (let key in this.search) {
        if (this.search[key])
          params[key] = this.search[key]
      }
      this.$axios.post('/laboratory/coal_laboratory/page', params).then(res => {
        this.data = res.data.data.list || []
        this.page.total = res.data.data.total
        this.loading = false
      }).catch(err => {
        console.log('model Err:', err)
        this.$set(this, 'loading', false)
      })
    },
    handleSizeChange(val) {
      this.page.size = val
      this.init()
    },
    handleCurrentChange(val) {
      this.page.current = val
      this.init()
    },
    setConfirm(row, type) {
      const params = {
        laboratoryId: row.id,
        confirm: type
      }
      this.$axios.post('/laboratory/coal_laboratory/confirm', params).then(() => {
        this.$message.success({ showClose: true, message: type === '1' ? '确认成功！' : '驳回成功！' })
        this.init()
      })
    }
  }
}
</script>

<style scoped>
.cf {
  overflow: hidden
}

.fl {
  float: left;
}

.fr {
  float: right;
}
</style>
